import { SolNavbar, SolNavbarItem } from '@sol/components';
import { SolIcon } from '@sol/icons';
import { PrototypeRouteId } from '../../../models/prototype-route-id';

export const dashboardBannersNavbar: SolNavbar = {
  menu: [
    SolNavbarItem.of(PrototypeRouteId.dashboard_banners_dashboard, {
      displayName: 'Dashboard',
      icon: SolIcon.dashboard,
    }),
    SolNavbarItem.of(PrototypeRouteId.dashboard_banners_admin, {
      displayName: 'Banners',
      icon: SolIcon.notification,
    }),
  ],
  system: [],
  account: [
    SolNavbarItem.of(PrototypeRouteId.account_section1, {
      children: [
        SolNavbarItem.of(PrototypeRouteId.account_preferences, {
          displayName: 'Preferences',
        }),
      ],
    }),
  ],
};
